module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/729f8aef73fe5151486419e055042a0c.png";